var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11,
    r: 11,
    fill: "#FF6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7413 10.5316L10.6561 8.5091C10.2837 8.26496 9.78906 8.53212 9.78906 8.97743L9.78906 13.0225C9.78906 13.4678 10.2837 13.735 10.6561 13.4909L13.7413 11.4683C14.0786 11.2472 14.0786 10.7528 13.7413 10.5316Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 16.88C14.7474 16.88 17.38 14.2474 17.38 11C17.38 7.75257 14.7474 5.12 11.5 5.12C8.25257 5.12 5.62 7.75257 5.62 11C5.62 14.2474 8.25257 16.88 11.5 16.88ZM11.5 18C15.366 18 18.5 14.866 18.5 11C18.5 7.13401 15.366 4 11.5 4C7.63401 4 4.5 7.13401 4.5 11C4.5 14.866 7.63401 18 11.5 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/Videos.77f33667171c5e7cc98842a5a56e1b17.svg";
export { ForwardRef as ReactComponent };